import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const load = () => {
  try {
    return JSON.parse(localStorage.getItem("flavors_cart") || "[]");
  } catch (e) {
    console.error("Failed to read saved cart:", e);
    return [];
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("flavors_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (entry) =>
    setItems((prev) => [
      ...prev,
      { ...entry, cartId: (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random()) },
    ]);

  const removeItem = (cartId) =>
    setItems((prev) => prev.filter((i) => i.cartId !== cartId));

  const updateQty = (cartId, q) =>
    setItems((prev) =>
      prev.map((i) => (i.cartId === cartId ? { ...i, quantity: Math.max(1, q) } : i))
    );

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);

  const value = useMemo(
    () => ({ items, addItem, removeItem, updateQty, clear, count, subtotal, open, setOpen }),
    [items, count, subtotal, open]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
